export default {
  getLocations: state => state.locations,
  getLocation: state => state.location,
  pagesCount: (state) => state.pagesCount,
  totalCountData: (state) => state.totalCountData,
}